export const TrackingSys = {
    IMPORT_MILESTONES: 1,
    EXPORT_MILESTONES: 2
}